/**
 * Report Slice
 * Manages state for reports including movement reports
 */

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as api from '../../services/api';

// Async thunks
export const fetchMovementReports = createAsyncThunk(
  'report/fetchMovementReports',
  async ({ customerId, startDate, endDate, limit } = {}, { rejectWithValue }) => {
    try {
      const params = {};
      if (startDate) params.startDate = startDate;
      if (endDate) params.endDate = endDate;
      if (limit) params.limit = limit;
      
      const response = customerId
        ? await api.getMovementReportsByCustomer(customerId, params)
        : await api.listMovementReports(params);
      
      return response.items || [];
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch movement reports');
    }
  }
);

const initialState = {
  movementReports: [],
  loading: false,
  error: null,
  filters: {
    customerId: null,
    startDate: null,
    endDate: null,
  },
};

const reportSlice = createSlice({
  name: 'report',
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    clearFilters: (state) => {
      state.filters = {
        customerId: null,
        startDate: null,
        endDate: null,
      };
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch movement reports
      .addCase(fetchMovementReports.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMovementReports.fulfilled, (state, action) => {
        state.loading = false;
        state.movementReports = action.payload;
      })
      .addCase(fetchMovementReports.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setFilters, clearFilters, clearError } = reportSlice.actions;

export default reportSlice.reducer;
